export const RUNDOCS_BASE_URL = "https://rundocs.com"

export const RUNDOCS_WELCOME = RUNDOCS_BASE_URL

export const RUNDOCS_BULK_UPSERT_BLOCKS = RUNDOCS_BASE_URL.concat(
  "/help/inventory/product-imports/"
)

export const RUNDOCS_RULE_BASED_TIERS = RUNDOCS_BASE_URL.concat(
  "/help/pricing/pricing-tiers/"
)

export const RUNDOCS_INVENTORY_COUNTS = RUNDOCS_BASE_URL.concat(
  "/help/inventory/inventory-counts/"
)

export const RUNDOCS_EXTERNAL_ACCOUNTING_QUICKBOOKS_INTEGRATION =
  RUNDOCS_BASE_URL.concat("/help/integrations/quickbooks/")

export const RUNDOCS_GIFT_CARDS = RUNDOCS_BASE_URL.concat(
  "/help/inventory/gift-cards/"
)
